import { MAILVISTA_DOMAIN_URLS } from "@/domain/entities/MailvistaUrl";
import MailvistaUrls from "@/domain/enums/MailvistaUrls";
import useFeatureFlag from "@/hooks/useFeatureFlag";
import useSetIsOnboardingDone from "@/hooks/useSetIsOnboardingDone";
import {
    setSettingsDialogTargetAndOpen,
    SettingsMenu,
} from "@/stores/settingsStore";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { Checkbox } from "../ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Label } from "../ui/label";
import YouTubeVideo from "./YouTubeVideo";

const OnboardingDialog = () => {
    const { t } = useTranslation();
    const { isWelcomeVideoDisplayed } = useFeatureFlag();
    const [isOpen, setIsOpen] = useState(isWelcomeVideoDisplayed);
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const { mutate: setOnboardingIsDone } = useSetIsOnboardingDone();

    useEffect(() => {
        setIsOpen(isWelcomeVideoDisplayed);
    }, [isWelcomeVideoDisplayed]);

    const handleClose = (value: boolean) => {
        setIsOpen(value);
        if (isChecked) {
            setOnboardingIsDone(true);
        }
    };

    return (
        <Dialog onOpenChange={handleClose} open={isOpen}>
            <DialogContent variant="youtube">
                <DialogHeader>
                    <DialogTitle className="text-center font-display text-3xl">
                        {t("onboardingDialog.title")}
                    </DialogTitle>
                </DialogHeader>

                <div className="space-y-4">
                    <p className="text-center">
                        {t("onboardingDialog.subtitle")}
                    </p>

                    <YouTubeVideo
                        className="w-full"
                        title="Tutoriel Mailvista"
                        videoURL={
                            MAILVISTA_DOMAIN_URLS[MailvistaUrls.ONBOARDINGVIDEO]
                                .url
                        }
                    />
                    <div className="flex justify-center">
                        <Button
                            onClick={() => {
                                handleClose(false);
                                setSettingsDialogTargetAndOpen(
                                    SettingsMenu.Resources,
                                );
                            }}
                            variant="outline"
                        >
                            {t("onboardingDialog.tutorialsLink")}
                        </Button>
                    </div>
                    <div className="flex justify-end gap-2">
                        <Checkbox
                            checked={isChecked}
                            id="onboarding-checkbox"
                            onCheckedChange={(checked) => {
                                setIsChecked(checked as boolean);
                            }}
                        />
                        <Label
                            className="cursor-pointer"
                            htmlFor="onboarding-checkbox"
                        >
                            {t("onboardingDialog.checkbox")}
                        </Label>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default OnboardingDialog;
